class PicturePopup {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="picture"]',
			productContent: '[data-scope="product"]',
			toggle: '.toggle-popup',
			productPopup: '.product-popup',
			href: '[data-href]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initEventListeners();
	}

	initEventListeners() {
		this.$scope.on('click', this.config.productContent, (event) => event.preventDefault());
		this.$scope.on('click', this.config.href, (event) => window.location = $(event.currentTarget).data('href'));
		this.$scope.on('click', this.config.toggle, (e) => this.toggleProductPopup(e));
		if (!window.matchMedia("(pointer: coarse)").matches) {
			this.$scope.on('mouseenter', this.config.toggle, (e) => this.openProductPopup(e));
		}
	}

	toggleProductPopup(event) {
		let $productContent = this.getCurrentProductContent(event);
		$productContent.find(this.config.productPopup).fadeToggle();
		$productContent.find(this.config.toggle).toggleClass('active');
	}

	openProductPopup(event) {
		let $productContent = this.getCurrentProductContent(event);
		$productContent.find(this.config.productPopup).fadeIn();
		$productContent.find(this.config.toggle).addClass('active');
	}

	getCurrentProductContent(event) {
		return $(event.currentTarget).closest(this.config.productContent)
	}
}

export default new PicturePopup;
